export const generateCaptchaToken = () => new Promise((resolve, reject) => {
  (<any>window).grecaptcha.ready(() => {
    (<any>window).grecaptcha.execute(process.env.REACT_APP_GRECAPTCHA_KEY, { action: 'login' })
      .catch(() => {
        reject(new Error('Captcha Token Failed'));
      })
      .then((token: string) => {
        resolve(token);
      });
  });
});
